export default __webpack_public_path__ + "static/media/googleScholar.e881e8ec.jpg";